import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { TipoParadaService } from './tipo-parada-service/tipo-parada.service';

@Component({
  selector: 'app-tipo-parada',
  templateUrl: './tipo-parada.component.html',
  styleUrls: ['./tipo-parada.component.scss']
})
export class TipoParadaComponent implements OnInit {

  display: boolean = false;
  carregando = true;
  tipoParadas: any[] = [];
  nomeNovoTipoEvento: string = '';

  tipoParadaParaExcluir: any = null;
  displayConfirmarExclusao: boolean = false;

  displayVinculos: boolean = false;
  carregandoVinculos: boolean = false;
  tipoParadaSelecionado: any = null;
  elementosDisponiveis: any[] = [];
  elementosVinculados: any[] = [];
  elementosDisponiveisFiltrados: any[] = [];
  elementosVinculadosFiltrados: any[] = [];
  alteracoesVinculos: boolean = false;
  termoPesquisaDisponiveis: string = '';
  termoPesquisaVinculados: string = '';

  constructor(
    private serviceTipoParada: TipoParadaService,
    private translate: TranslateService,
    private router: Router,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.carregando = true;
    this.carregarTipoParadas();
  }

  adicionarTipoParada(nomeTipoParada: string) {
    if (!nomeTipoParada || nomeTipoParada.trim() === '') {
      this.exibirErro(this.translate.instant('parametros.tipoParada.nomeObrigatorio'), this.translate.instant('parametros.tipoParada.erro'));
      return;
    }

    // Verificar se já existe um tipo de evento com este nome
    const tipoParadaExistente = this.tipoParadas.find(f =>
      f.nome.toLowerCase() === nomeTipoParada.toLowerCase()
    );

    if (tipoParadaExistente) {
      this.exibirErro(this.translate.instant('parametros.tipoParada.tipoParadaJaExiste'), this.translate.instant('parametros.tipoParada.erro'));
      return;
    }

    this.serviceTipoParada.adicionarTipoParada(nomeTipoParada.trim()).then((response: any) => {
      this.exibirSucesso(
        this.translate.instant('parametros.tipoParada.tipoParadaAdicionado'),
        this.translate.instant('parametros.tipoParada.sucesso')
      );
      this.nomeNovoTipoEvento = '';
      this.display = false;
      this.carregarTipoParadas();
    })
  }

  carregarTipoParadas() {
    this.carregando = true;
    this.tipoParadas = [];

    this.serviceTipoParada.getTipoParada().then((response: any) => {

      const dadosTipoParadas = Array.isArray(response?.data) ? response.data : response;

      if (dadosTipoParadas && Array.isArray(dadosTipoParadas)) {
        this.tipoParadas = dadosTipoParadas.map((tipoParadas: any) => ({
          id: tipoParadas.idPadraoTipoParada ?? tipoParadas.id,
          nome: tipoParadas.descParadaFab ?? tipoParadas.descTipoEvento ?? tipoParadas.nome,
          vinculos: tipoParadas.countParadas ?? tipoParadas.vinculos ?? 0
        }));
      }
      this.carregando = false;

    }).catch((error: any) => {
      this.carregando = false;
      console.error('Erro ao carregar tipo paradas:', error);
      this.tratarErro(
        this.translate.instant('parametros.tipoParada.erroCarregarTipoParada'),
        this.translate.instant('parametros.tipoParada.erro'),
        error
      );
    });
  }

  removerTipoParada(idTipoParada: number) {
    const index = this.tipoParadas.findIndex(f => f.id === idTipoParada);
    if (index > -1) {
      const tipoParadaRemovido = this.tipoParadas[index];

      // Verificar se há vínculos ativos
      if (tipoParadaRemovido.vinculos > 0) {
        const mensagem = this.translate.instant('parametros.tipoParada.naoPodeRemoverComVinculos')
          .replace('{nome}', tipoParadaRemovido.nome)
          .replace('{vinculos}', tipoParadaRemovido.vinculos.toString());
        this.exibirErro(mensagem, this.translate.instant('parametros.tipoParada.avisoVinculosAtivos'));
        return;
      }

      // Mostrar modal de confirmação
      this.tipoParadaParaExcluir = tipoParadaRemovido;
      this.displayConfirmarExclusao = true;
    }
  }

  confirmarExclusao() {
    if (!this.tipoParadaParaExcluir) return;

    // Chamada para o backend para remover o tipo de parada
    this.serviceTipoParada.removerTipoParada(this.tipoParadaParaExcluir.id).then((response: any) => {
      this.exibirSucesso(
        this.translate.instant('parametros.tipoParada.tipoParadaRemovido'),
        this.translate.instant('parametros.tipoParada.sucesso')
      );
      this.hideDialogConfirmarExclusao();

      // Recarregar a lista de tipos de parada após remover
      this.carregarTipoParadas();
    })
      .catch((error: any) => {
        this.tratarErro(
          this.translate.instant('parametros.tipoParada.erroRemoverTipoParada'),
          this.translate.instant('parametros.tipoParada.erro'),
          error
        );
      });
  }

  hideDialogConfirmarExclusao() {
    this.displayConfirmarExclusao = false;
    this.tipoParadaParaExcluir = null;
  }

  exibirErro(mensagem: string, titulo: string) {
    this.toastr.error(mensagem, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }

  exibirSucesso(mensagem: string, titulo: string) {
    this.toastr.success(mensagem, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }

  tratarErro(mensagem: string, titulo: string, error: any) {
    this.carregando = false;
    let msg: string;
    try {
      if (error.status === 401) {
        this.router.navigateByUrl('logout');
      }
      msg = mensagem + '\n' + error.erro;
    } catch (Exception) {
      msg = mensagem;
    }
    this.toastr.error(msg, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }

  verVinculos(tipoParada: any) {

    this.tipoParadaSelecionado = tipoParada;
    this.elementosDisponiveis = [];
    this.elementosVinculados = [];
    this.elementosDisponiveisFiltrados = [];
    this.elementosVinculadosFiltrados = [];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
    this.carregandoVinculos = true;
    this.displayVinculos = true;

    this.carregarElementosVinculos(tipoParada.id);
  }

  carregarElementosVinculos(tipoParadaId: number) {
    this.serviceTipoParada.getVinculosTipoParada(tipoParadaId).then((response: any) => {
      let dadosVinculos = response;

      if (response && response.data) {
        dadosVinculos = response.data;
      }

      if (!dadosVinculos) {
        dadosVinculos = {
          disponiveis: [],
          vinculados: []
        };
      }

      this.processarVinculosTipoParada(dadosVinculos);
      this.carregandoVinculos = false;
    })
      .catch((error: any) => {
        console.error('Erro ao carregar vínculos:', error);
        this.carregandoVinculos = false;
        this.tratarErro(
          this.translate.instant('parametros.tipoParada.erroCarregarVinculos'),
          this.translate.instant('parametros.tipoParada.erro'),
          error
        );
      });
  }

  private processarVinculosTipoParada(dadosVinculos: any) {

    this.elementosDisponiveis = (dadosVinculos.disponiveis || []).map((item: any, index: number) => ({
      id: `disp_${index}`,
      nome: item.descTipoParada,
      vinculado: false
    }));

    this.elementosVinculados = (dadosVinculos.vinculados || []).map((item: any, index: number) => ({
      id: `vinc_${index}`,
      nome: item.descTipoParada,
      vinculado: true
    }));

    this.elementosDisponiveisFiltrados = [...this.elementosDisponiveis];
    this.elementosVinculadosFiltrados = [...this.elementosVinculados];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
  }

  vincularTodosFiltrados() {
    if (this.elementosDisponiveisFiltrados.length === 0) return;
    const elementosParaVincular = [...this.elementosDisponiveisFiltrados];

    elementosParaVincular.forEach(elemento => {
      if (!elemento.vinculado) {
        const index = this.elementosDisponiveis.findIndex(e => e.id === elemento.id);
        if (index > -1) {
          this.elementosDisponiveis.splice(index, 1);
        }

        elemento.vinculado = true;
        this.elementosVinculados.push(elemento);
      }
    });

    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;
  }

  removerVinculo(elemento: any) {
    const index = this.elementosVinculados.findIndex(e => e.id === elemento.id);
    if (index > -1) {
      this.elementosVinculados.splice(index, 1);
    }

    elemento.vinculado = false;
    this.elementosDisponiveis.push(elemento);
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;
  }

  removerTodosVinculos() {
    if (this.elementosVinculados.length === 0) return;

    // Remover todos os vínculos
    this.elementosVinculados.forEach(elemento => {
      elemento.vinculado = false;
      this.elementosDisponiveis.push(elemento);
    });

    this.elementosVinculados = [];
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;
  }

  filtrarElementosDisponiveis() {
    if (!this.termoPesquisaDisponiveis || this.termoPesquisaDisponiveis.trim() === '') {
      this.elementosDisponiveisFiltrados = [...this.elementosDisponiveis];
    } else {
      const termo = this.termoPesquisaDisponiveis.toLowerCase().trim();
      this.elementosDisponiveisFiltrados = this.elementosDisponiveis.filter(elemento =>
        elemento.nome.toLowerCase().includes(termo) ||
        (elemento.criadoPor && elemento.criadoPor.toLowerCase().includes(termo))
      );
    }
  }

  filtrarElementosVinculados() {
    if (!this.termoPesquisaVinculados || this.termoPesquisaVinculados.trim() === '') {
      this.elementosVinculadosFiltrados = [...this.elementosVinculados];
    } else {
      const termo = this.termoPesquisaVinculados.toLowerCase().trim();
      this.elementosVinculadosFiltrados = this.elementosVinculados.filter(elemento =>
        elemento.nome.toLowerCase().includes(termo) ||
        (elemento.criadoPor && elemento.criadoPor.toLowerCase().includes(termo))
      );
    }
  }

  hideDialogVinculos() {
    this.displayVinculos = false;
    this.carregandoVinculos = false;
    this.tipoParadaSelecionado = null;
    this.elementosDisponiveis = [];
    this.elementosVinculados = [];
    this.elementosDisponiveisFiltrados = [];
    this.elementosVinculadosFiltrados = [];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
  }

  // TrackBy function para otimizar performance
  trackByElemento(index: number, elemento: any): number {
    return elemento.id;
  }

  limparPesquisaDisponiveis() {
    this.termoPesquisaDisponiveis = '';
    this.filtrarElementosDisponiveis();
  }

  limparPesquisaVinculados() {
    this.termoPesquisaVinculados = '';
    this.filtrarElementosVinculados();
  }

  adicionarVinculo(elemento: any) {
    if (elemento.vinculado) return;

    const index = this.elementosDisponiveis.findIndex(e => e.id === elemento.id);
    if (index > -1) {
      this.elementosDisponiveis.splice(index, 1);
    }

    elemento.vinculado = true;
    this.elementosVinculados.push(elemento);
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;
  }

  salvarVinculos() {
    if (!this.alteracoesVinculos) return;

    this.serviceTipoParada.salvarVinculosTipoParada(this.tipoParadaSelecionado.id, this.elementosVinculados).then((response: any) => {
      this.tipoParadaSelecionado.vinculos = this.elementosVinculados.length;
      const tipoParadaIndex = this.tipoParadas.findIndex(f => f.id === this.tipoParadaSelecionado.id);

      if (tipoParadaIndex > -1) {
        this.tipoParadas[tipoParadaIndex].vinculos = this.elementosVinculados.length;
      }

      this.exibirSucesso(
        this.translate.instant('parametros.tipoParada.vinculosSalvos'),
        this.translate.instant('parametros.tipoParada.sucesso')
      );
      this.alteracoesVinculos = false;
      this.hideDialogVinculos();
    })
      .catch((error: any) => {
        this.tratarErro(
          this.translate.instant('parametros.tipoParada.erroSalvarVinculos'),
          this.translate.instant('parametros.tipoParada.erro'),
          error
        );
      });
  }
}
